import React from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import { Dropdown } from '@src/components/ui/Dropdown';
import { useAllStatesQuery } from '@src/hooks/queries/states';


const StatesDropdown = ({ selectedState, onChange }) => {
    const statesQuery = useAllStatesQuery();

    const { isLoading, states } = React.useMemo(() => {
        let states;

        const isLoading = statesQuery.isLoading;
        states = get(statesQuery, ['data', 'states'], []);

        states = states.map((state) => ({
            id: state.slug,
            title: state.name,
        }));

        return { isLoading, states };
    }, [statesQuery]);

    const handleDropdownChange = React.useCallback((value) => {
        if (value === Dropdown.ALL_OPTION) {
            value = null;
        }

        if (onChange) onChange(value);
    }, [onChange]);

    return (
        <Dropdown
            defaultSelection="State"
            title="State"
            list={states}
            isLoading={isLoading}
            selectedOption={selectedState}
            onChange={handleDropdownChange}
        />
    );
};

StatesDropdown.propTypes = {
    selectedState: PropTypes.string,
    onChange: PropTypes.func,
};

export default StatesDropdown;
